<template>
    <div class="">

    <v-row>
        <v-col cols="12">
            <v-row
            style="display: flex; flex-direction: row; justify-content: space-between; flex-wrap: nowrap;"
            no-gutters>
                    
             <div style="width: 100%;cursor:pointer; display: flex; justify-content: center;"> <v-icon>{{
               "mdi-drag-horizontal" }}</v-icon> </div>
                    
            <div style="cursor:pointer;"> <v-btn  :disabled="waybillStatus=='Completed' || userRoleId==5
                || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)" icon @click="removeDeliveryAddress()" ><v-icon color="red">{{ "mdi-delete-outline" }}</v-icon> </v-btn>
            </div>
                    
            </v-row>
            <v-row style="display:flex;justify-content: space-between;">
            <v-col no-gutters >

                <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;" class="mb-3">

                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        label="Station Name"
                        dense
                        outlined
                        hide-details
                        v-model="element.name"
                    ></v-text-field>
                </v-col>
                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-select :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        :items="delivery_types"
                        label="Delivery Type"
                        v-model="element.deliveryType"
                        hide-details
                        dense
                        outlined
                    ></v-select>
                    <!-- {{element.coordinate.lat}},{{element.coordinate.lng}} -->
                </v-col>
            </v-row>

            <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;" class="mb-3">

                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        label="Pickup City"
                        dense
                        outlined
                        hide-details
                        v-model="element.pickupCity"
                    ></v-text-field>
                </v-col>
                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        label="Drop City"
                        dense
                        outlined
                        hide-details
                        v-model="element.dropCity"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;" class="mb-3">

                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        label="Longitude"
                        dense
                        outlined
                        hide-details
                        v-model="element.coordinate.lng"
                    ></v-text-field>
                </v-col>
                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        label="Latitude"
                        dense
                        outlined
                        hide-details
                        v-model="element.coordinate.lat"
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;" class="mb-3">

                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-menu :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        v-model="fromDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y 
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                            label="Estimated Delivery Date"
                            readonly
                            hide-details
                            dense
                            outlined
                            :value="element.deliveryDate"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                            locale="en-in"
                            v-model="element.deliveryDate"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-menu :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        ref="menu"
                        v-model="time_menu_visible"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="element.deliveryTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                                v-model="element.deliveryTime"
                                label="Estimated Delivery Time"
                                readonly
                                dense
                                outlined
                                hide-details
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-time-picker :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                            v-if="time_menu_visible"
                            v-model="element.deliveryTime"
                            full-width
                            @click:minute="$refs.menu.save(element.deliveryTime)"
                        ></v-time-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;" class="mb-3">

                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-menu :disabled="true"
                        v-if="element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0"
                        v-model="fromDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y 
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field :disabled="true"
                            label="Actual Delivery Date"
                            prepend-icon="event"
                            readonly
                            hide-details
                            dense
                            outlined
                            :value="localDate"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker :disabled="true"
                            locale="en-in"
                            v-model="localDate"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col style="padding: 0;" cols="12" sm="6">
                    <v-menu :disabled="true"
                        v-if="element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0"
                        ref="menu"
                        v-model="time_menu_visible"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="element.actualDeliveryTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field :disabled="true"
                                v-model="localTime"
                                label="Actual Delivery Time"
                                prepend-icon="access_time"
                                readonly
                                dense
                                outlined
                                hide-details
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-time-picker :disabled="true"
                            v-if="time_menu_visible"
                            v-model="localTime"
                            full-width
                        ></v-time-picker>
                    </v-menu>
                </v-col>
            </v-row>

                <!-- <v-col 
                    v-if="1===2"
                    cols="2" style="max-width:80px;width:80px;height:80px;margin-top:-20px;">
                    <v-img v-if="element.qrCodeMedia !== undefined && element.qrCodeMedia.url !== undefined"
                        height="75"
                        :src="element.qrCodeMedia.url"
                        contain
                    >
                    </v-img>
                    <v-btn v-else :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        color="primary"
                        width="100%"
                        @click="generateQrCode()"
                    >
                        Generate QrCode for Waybill
                    </v-btn>
                </v-col> -->
               
                <v-spacer/>
                <!-- <v-col cols='1' style="display:flex;justify-content: flex-end;">
                    <v-btn  :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)" raised @click="removeDeliveryAddress()" color='error'><v-icon>close</v-icon></v-btn>
                </v-col> -->
                <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;" class="mb-3">

                <v-col v-for="(field,index) in selects" :key="`multi_${field.value}_${index}`" style="padding: 0;" cols="12" sm="6">
                    <label class="typo__label">{{field.text}}</label>
                    <multiselect  :disabled="waybillStatus=='Completed' || userRoleId==5
                    || (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                        v-model="element.packages" 
                        :tag-placeholder="`Select ${field.entity}`" 
                        :placeholder="`Search for ${field.entity}`" 
                        :label="field.selector" 
                        :track-by="field.selector" 
                        :options="entities[field.entity]" 
                        :multiple="field.multiple" 
                        :taggable="true"
                        :hide-selected="true"
                        :class="generateChipStyle(field.chipColor)"
                        style="background:none !important"
                    >
                    </multiselect>
                </v-col>
                </v-row>
                <v-row no-gutters style="gap: 6px;" class="mb-3" :disabled="waybillStatus=='Completed' || userRoleId==5|| (element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)"
                    v-if="(element.invoiceMedias !== undefined  && element.invoiceMedias.length !== 0)">
                    <v-col style="padding: 0;flex:1;" cols="4" sm="6"
                        v-for="(invoiceMedia,idx) in element.invoiceMedias" 
                        :key="'media'+idx"
                    >
                        <v-card style="display:flex;flex-direction:column;align-items:center"> 
                        <v-img    
                                    :src="invoiceMedia.url"
                                    height="100"
                                    width="100"
                                    :key="invoiceMedia.Id"
                                    contain
                                >
                                </v-img> 
                        <v-btn   
                                    color="success" 
                                    @click="printWaybillInvoice(invoiceMedia.url)"
                                    width="100%"
                                    :key="invoiceMedia.Id"
                                >
                                    <v-icon>print</v-icon> Waybill Invoice
                                </v-btn>
                        </v-card>
                    </v-col>
                    </v-row>
            </v-col>
            </v-row>

             
 
        </v-col>
        <!-- <v-col cols='6' class="control-div">
                    <v-btn 
                        color="success"
                        width="100%"
                        @click="printPackagesQrCodes()"
                    >
                        <v-icon>print</v-icon> Packages QR Codes
                    </v-btn>
                </v-col> -->
    </v-row>
</div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import {mapState,mapActions} from 'vuex'
import Utils from '../../mixins/utils'
import moment from 'moment'
import 'moment-timezone';
export default {
    data(){
        return {
            
            userRoleId:localStorage.getItem("UserRoleId"),
            waybillStatus:localStorage.getItem("SelectedwaybillStatus"),
            delivery_types :[
                'Pick Up',
                'Drop Off'
            ],
            time_menu_visible:false,
            fromDateMenu:false,
            visible:true
        }
    },
    mixins:[Utils],
    props: {
        element:Object,
        index:0,
        selects:Array, //the header item fields
    },
    computed: {
         ...mapState('entities',['loading','current_entity','entities','search','selected_search_entity']),
         ...mapState('users',['user']),
         localTime: {
            get() {
                // return this.element.actualDeliveryDate;
                // Convert the date to KSA timezone
                try {
                    const originalDate = this.element.actualDeliveryDate + ' ' + this.element.actualDeliveryTime
                    var utcCutoff = moment.utc(originalDate, 'DD-MM-YYYY HH:mm:ss');
                    const ksaDate = utcCutoff.clone().tz('Asia/Riyadh');
                    const convertedTime = ksaDate.format('HH:mm:ss');
                    return convertedTime;
                }
                catch (e) {
                    return this.element.actualDeliveryTime
                }
            },
            set(val) {

            }
        },
        localDate: {
            get() {
                //return this.element.actualDeliveryTime;
                // Convert the date to KSA timezone
                try {
                    const originalDate = this.element.actualDeliveryDate + ' ' + this.element.actualDeliveryTime
                    console.log(originalDate);
                    var utcCutoff = moment.utc(originalDate, 'DD-MM-YYYY HH:mm:ss');
                    const ksaDate = utcCutoff.clone().tz('Asia/Riyadh');
                    const convertedDate = ksaDate.format('DD-MM-YYYY');
                    return convertedDate;
                }
                catch (e) {
                    return this.element.actualDeliveryDate
                }
            },
            set(val) {

            }
        }
    },
    components: {Multiselect},
    methods:{
        ...mapActions('users',['isAdmin'],['isClient']),
        removeDeliveryAddress() {
            this.$emit('removeDeliveryAddress',this.index);
        },
        generateChipStyle(color) {
            var styleDef = `.${color} .multiselect__tag{background:${color} !important;}`
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = styleDef;
            document.head.appendChild(style);
            return color;
        },
        openTimeComponent() {
            this.time_menu_visible = true;
        },
        generateQrCode(){

        },
        printPackagesQrCodes(){

        },
        printWaybillInvoice(url){
            var win = window.open(url, '_blank');
            win.window.print();
            win.focus();
        }
    },
    watch:{
        element(){
            this.$emit("elementChanged");
        }
    },
    mounted() {
        this.element.deliveryDate = this.getReadableDate(this.element.deliveryDate);
    }
}
</script>
<style lang="scss">
.control-div{
    padding-bottom: 0 !important;
}
</style>